import _merge from 'lodash/merge';
import Store from 'lightningjs-redux';
import { Lightning } from '@lightningjs/sdk';
import { imageService } from '@bedrock/fido-sdk';
import { DEFAULT_IMAGE_FORMAT, IMAGE_FIT_SCALE_CROP, IMAGE_QUALITY } from '@bedrock-rdk/constants';
import { getInitialStyle } from './ageGatePopup.style';
import { t } from '../../i18n';
import { Button } from '../../tornado/button/button.component';
import { HIDE_POPUP_SIGNAL, ROUTE_BACK_SIGNAL } from '../../popupContainer/popupContainer.constants';
import Icon from '../../tornado/icon/icon.component';
import { createItemAction } from '../../cta/cta.actions';
import { cover } from '../../tornado/utils/textures';
import { findVideoItemProgramImageId } from '../../../logic/player/player.utils';

export class AgeGatePopup extends Lightning.Component {
  static _template() {
    return _merge(getInitialStyle(), {
      FlexContainer: {
        IconWrapper: {
          Icon: {
            type: Icon,
          },
        },
        Title: {
          text: {
            text: t('popups.ageGate.heading'),
          },
        },
        Description: {
          text: {
            text: t('popups.ageGate.body'),
          },
        },
        ButtonsSection: {
          CancelButton: {
            type: Button,
            label: t('global.cancel'),
          },
          OkButton: {
            type: Button,
            label: t('global.continue'),
          },
        },
      },
      passSignals: {
        [HIDE_POPUP_SIGNAL]: true,
        [ROUTE_BACK_SIGNAL]: true,
      },
    });
  }

  set routeBackOnClose(value) {
    this._routeBackOnClose = value;
  }

  set payload(value) {
    this._payload = value;
    const { finalW, finalH } = this;
    const { item } = value;
    this.tag('BackgroundPoster').texture = cover(
      imageService.getUrl(findVideoItemProgramImageId(item), finalW, finalH, {
        fit: IMAGE_FIT_SCALE_CROP,
        quality: IMAGE_QUALITY,
        format: DEFAULT_IMAGE_FORMAT,
      }),
      finalW,
      finalH,
    );
  }

  _build() {
    this._index = 0;
    this._buttons = this.tag('ButtonsSection').children;
  }

  _getFocused() {
    return this._buttons[this._index];
  }

  _handleRight() {
    if (this._index < this._buttons.length - 1) {
      this._setIndex(this._index + 1);

      return true;
    }

    return false;
  }

  _handleLeft() {
    if (this._index > 0) {
      this._setIndex(this._index - 1);

      return true;
    }

    return true;
  }

  _handleEnter() {
    if (this._index === 1 && this._payload) {
      this.signal(HIDE_POPUP_SIGNAL);

      Store.dispatch(createItemAction(this._payload));
    } else {
      this.signal(this._routeBackOnClose ? ROUTE_BACK_SIGNAL : HIDE_POPUP_SIGNAL);
    }

    return true;
  }

  _handleBack() {
    this.signal(this._routeBackOnClose ? ROUTE_BACK_SIGNAL : HIDE_POPUP_SIGNAL);

    return true;
  }

  _setIndex(value) {
    this._index = value;
  }
}
